import { createContext } from "react";

interface IStationRouteContext {
  rideOpenerId?: number;
}

export const StationRouteContext = createContext<IStationRouteContext>({});
